export const DesktopMaximumAdHeight = 600;
